import { WidgetTypes } from '../../typings';
import { LegacyQnrItemExtBase, IQnrItemExtParsedExt } from '../extension-base';

export class QuestionnaireItemRenderLabelAsMarkdown extends LegacyQnrItemExtBase {
  extensionUrl = 'http://zitelab.eu/fhir/extensions/renderLabelAsMarkdown';
  supportedWidgets = [WidgetTypes.All];
  constructor(config: Record<string, unknown> = {}) {
    super(config);
  }

  parse = (): IQnrItemExtParsedExt => {
    let renderLabelAsMarkdown = false;
    if (this.extensionJson?.valueBoolean) {
      renderLabelAsMarkdown = this.extensionJson.valueBoolean;
    }

    return {
      widgetProperties: {
        renderLabelAsMarkdown,
      },
    };
  };
}

export function getRenderLabelAsMarkdown(item: fhir4.QuestionnaireItem) {
  let extensionObj: QuestionnaireItemRenderLabelAsMarkdown;
  if (item?.extension) {
    // the FHIR resource is already validated at this point
    item.extension.forEach((extension) => {
      if (
        extension.url ===
        'http://zitelab.eu/fhir/extensions/renderLabelAsMarkdown'
      ) {
        extensionObj = new QuestionnaireItemRenderLabelAsMarkdown({
          extensionJson: extension,
        });
      }
    });
  }
  return extensionObj !== undefined
    ? extensionObj.parse().widgetProperties
    : {};
}
